<template>
  <div class="flex justify-center items-center">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
